import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import EmptyState from 'assets/images/data-room-empty-image.webp';

import './ShareableLinkNdaProcessing.styles.scss';

type ShareableLinkNdaProcessingProps = {
  className?: string;
};

const ShareableLinkNdaProcessing: React.FC<ShareableLinkNdaProcessingProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-nda-processing', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      image={EmptyState}
      title={t('ndaProcessing')}
      description={t('ndaIsBeingProcessing')}
    />
  );
};

export default ShareableLinkNdaProcessing;
